import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SupportedChannelMessageEnum } from '../../../helpers/supported-channel-message.enum';
import { HostChannelService } from '../../../services/host-channel.service';

@Component({
  standalone: false,
  selector: 'app-service-unavailable',
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.scss'],
})
export class ServiceUnavailableComponent {
  constructor(
    private readonly router: Router,
    private readonly hostChannelService: HostChannelService,
  ) {}

  postChannelMessage(): void {
    this.hostChannelService.postMessage({
      type: SupportedChannelMessageEnum.REINITIALIZE,
    });
  }
}
